import { render, staticRenderFns } from "./apiCidadao.vue?vue&type=template&id=443a9d1c&"
import script from "./apiCidadao.vue?vue&type=script&lang=js&"
export * from "./apiCidadao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports